import React from 'react'
import clsx from 'clsx'
import {Row} from 'react-table'

/**
 * Componente para renderizar una fila personalizada en una tabla que utiliza `react-table`.
 *
 * Este componente toma una fila de `react-table` y la renderiza, iterando sobre cada celda de la fila.
 * Para cada celda, se aplican las propiedades necesarias y se renderiza el contenido de la celda
 *
 * @param {Props<T>} props - Propiedades del componente.
 * @param {Row<T>} props.row - Instancia de la fila de `react-table` que se va a renderizar.
 * @returns {React.FC<Props<T>>} Un componente funcional de React que renderiza una fila de tabla personalizada.
 *
 * @example
 * // Uso en una tabla de `react-table`
 * rows.map((row: Row<T>, i) => {
 *   prepareRow(row);
 *   return <CustomRow key={i} row={row} />;
 * })
 */

type Props<T extends object> = {
  row: Row<T>
}

function CustomRow<T extends object>({row}: Props<T>) {
  return (
    <tr {...row.getRowProps()}>
      {row.cells.map((cell) => {
        return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
      })}
    </tr>
  )
}

export {CustomRow}
